import { render } from "./autorise-zone.vue?vue&type=template&id=0faa52a8"
import script from "./autorise-zone.vue?vue&type=script&lang=js"
export * from "./autorise-zone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__